module.exports = __webpack_public_path__ + "images/icon-installer-ribbon.a3a0af.svg";